import { useMemo, type ReactNode } from 'react'
import { useQuery } from '@tanstack/react-query'
import { PhotosCtx } from './common'
import { apiGet } from '../lib/api'
import { qk } from '../lib/queryClient'
import { mapaDeFotos } from '../lib/autoria'
import type { PersonaVista, TeamMember } from '../lib/types'

// Proveedor de las fotos de Google del roster para todos los Avatar de la app
// (montado en RequireAuth). Separado de common.tsx a propósito: apiGet arrastra
// firebase/auth y common.tsx lo importan tests que corren en node.
export function PhotosProvider({ children }: { children: ReactNode }) {
  const { data } = useQuery({
    queryKey: qk.team,
    queryFn: () => apiGet<{ members: TeamMember[]; personas?: PersonaVista[] }>('/api/team'),
    staleTime: 5 * 60_000,
  })
  // Roster primero; después las fotos del directorio histórico (D-25), solo de
  // internos: quien escribió en Basecamp y aún no entra se ve con su foto, y el día
  // que entra con Google manda la de su cuenta.
  const mapa = useMemo(() => mapaDeFotos(data?.members ?? [], data?.personas ?? []), [data])
  return <PhotosCtx.Provider value={mapa}>{children}</PhotosCtx.Provider>
}
